module.exports = __webpack_public_path__ + "media/images/restaurant/en_sarvicegenre_bg01-48f39b3d5be3479f8a1db119a68a9db2.png";